var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cy-electricity"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('electricity.sockets.description'))}}),_c('SwitchesSocketsSerieSelector'),_c('ElectricityOptions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }